import React from 'react'
import {Container} from "reactstrap"
import { FaInstagram, FaFacebookSquare,FaYoutube} from 'react-icons/fa';

const Footer = ()=> {
    return (
        <div className="footer py-4 text-white">
            <Container>
                <h4>Support</h4>
                <p className="mb-4">In case of any issues with registration or website you can contact us at <a className="mail" href="mailto:vidyutrenz.ece@citchennai.net">vidyutrenz.ece@citchennai.net</a><br></br>+91 73389 87338 - Madhesh<br></br>+91 98941 07330 - Supraja</p> 
                <h4>Connect With Us</h4>
                <a href="https://www.instagram.com/cit.vidyutrenz/" className="mr-2 icon insta"><FaInstagram size="1.6rem"></FaInstagram></a>
                <a href="https://www.facebook.com/vidyutrenz/" className="mx-2 icon fb"><FaFacebookSquare size="1.5rem"></FaFacebookSquare></a>
                <a href="https://www.youtube.com/channel/UCzL_aK9Mj6jCtQhAyRZFE1g" className="mx-2 icon yt"><FaYoutube size="1.6rem"></FaYoutube></a>
            </Container>
        </div>
    )
}

export default Footer;